<template>
  <div class="content animate-panel" id="content">
    <h2 class="m-n">商品管理</h2>
    <div class="hpanel">
      <nav-tabs :tab="tab"></nav-tabs>
      <tab-content :tab="tab"></tab-content>
    </div>
  </div>
</template>
<script>
import NavTabs from './NavTabs'
import TabContent from './TabContent'

export default {
  components: {
    NavTabs,
    TabContent
  },
  data () {
    return {
      tab: null,
      loader: null
    }
  },
  mounted () {
    this.$events.listen('done', () => {
      this.loader && this.loader.hide()
    })
  },
  watch: {
    $route (to, from) {
      const fromTab = from.params.tab
      const toTab = to.params.tab
      if (fromTab !== toTab && ['list', 'add-by-amazon', 'reports'].includes(toTab)) {
        this.tab = toTab
      } else {
        this.$router.push('/not-found')
      }
    }
  },
  created () {
    this.tab = this.$route.params.tab
    if (['list', 'add-by-amazon', 'reports'].includes(this.tab)) {
      this.loader = this.$loading.show()
    } else {
      this.$router.push('not-found')
    }
  },
  beforeDestroy () {
    this.$events.remove('done')
    this.loader && this.loader.hide()
  }
}
</script>

<style>
#wrapper {
  background: #f9f9f9 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/productsNew/Products.vue